$optimade_zero_search $mol_book2
	menu_title \Поиск
	parsed_query null
	mpds_api $optimade_zero_api
		search_params <= parsed_query
		selectize_params? <= search?
	pages /
		<= Filters_page $mol_page
			title \Фильтры
			body /
				<= Search_filters $mol_row sub <= search_filters /
					<= Search_filter*0 $mol_button_major
						hint \Убрать
						click? <=> clear_search_filter*? null
						sub / <= Search_labeler* $mol_labeler
							title <= search_labeler_title* \Chemical formulae
							content /
								<= Search_labeler_content* $mol_paragraph title <= search_labeler_content* \Формула
				<= Filter_elements_labeler $mol_labeler
					title \Chemical elements
					content /
						<= Elements_filter $mol_check_list
							options <= refinement_filter_options*elements *
				<= Filter_props_labeler $mol_labeler
					title \Physical properties
					content /
						<= Props_filter $mol_check_list
							options <= refinement_filter_options*props *
				<= Filter_classes_labeler $mol_labeler
					title \Materials classes
					content /
						<= Classes_filter $mol_check_list
							options <= refinement_filter_options*classes *
				<= Filter_lattices_labeler $mol_labeler
					title \Crystal systems
					content /
						<= Lattices_filter $mol_check_list
							options <= refinement_filter_options*lattices *
		<= Result_page $mol_page
			title \Поиск
			Title null
			tools /
				<= Search_row $mol_row sub /
					<= Search $mol_search
						hint \Type property, elements, classes
						query? <=> search? \
						suggests <= suggests /
					<= Search_button $mol_button_major
						title \Искать
						click? <=> fetch_search? null
				<= View_type_row $mol_row sub /
					<= View_type_switch $mol_switch
						value? <=> search_type? \0
						options *
							0 \entires
							1 \phases
							2 \articles
			body /
				<= Row_cards $mol_list rows <= card_list /
					<= Card*0 $mol_row sub /
						<= Image* $mol_image
							uri <= get_image* \
						<= Facet_info* $mol_list rows /
							<= Classes* $mol_html_view html <= get_classes* \
							<= Description* $mol_html_view html <= get_description* \
